import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import ReactStars from "react-rating-stars-component";
import { VscClose } from "react-icons/vsc";
import Modal from "../atoms/Modal/Modal";
import Button from "../atoms/Button/Button";
import SVGIcon from "../atoms/SVGIcon";
import TextArea from "../atoms/TextArea/TextArea";

const Feedback = ({ handler = () => {} }) => {
    const [value, setValue] = useState(0);
    const [feedbackModal, setFeedbackModal] = useState(false);
    const [text, setText] = useState("");
    const [thankYou, setThankYou] = useState("");

    function handleClose() {
        setFeedbackModal(false);
        setValue(0);
        setText("");
        setThankYou("");
    }
    return (
        <div>
            {feedbackModal && (
                <Modal
                    setModal={
                        !thankYou
                            ? () => {}
                            : () => {
                                  handleClose();
                              }
                    }
                >
                    <div className={styles.feedbackModalWrapper}>
                        {!thankYou ? (
                            <>
                                <div
                                    className={styles.closeCta}
                                    onClick={() => {
                                        setValue(0);
                                        setFeedbackModal(false);
                                    }}
                                >
                                    <VscClose size={22} color="#6b6b6b" />
                                </div>
                                <div className={styles.tagline}>
                                    Tell Us What You Think
                                </div>
                                <div className={styles.starsWrap}>
                                    <div className={styles.starsLabel}>
                                        Rate Your Experience
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <ReactStars
                                            classNames={styles.starry}
                                            size={35}
                                            count={5}
                                            value={value}
                                            onChange={(newVal) => {
                                                setValue(newVal);
                                            }}
                                            color={"var(--tertiary-color3)"}
                                            // activeColor={"var(--primary-color1)"}
                                        />
                                    </div>
                                </div>
                                {value > 0 && (
                                    <div className={styles.boxWrap}>
                                        <div className={styles.boxLabel}>
                                            {value < 4
                                                ? "Let us know what went wrong?"
                                                : "Let us know what worked for you?"}
                                        </div>
                                        <TextArea
                                            width="100%"
                                            props={{
                                                value: text || "",
                                                placeholder:
                                                    "Comments & Suggestions",
                                                onChange: (e) => {
                                                    let val =
                                                        e?.target?.value || "";
                                                    if (val.length > 200) {
                                                        return;
                                                    }
                                                    setText(val);
                                                },
                                                style: {
                                                    outline: "none",
                                                    flexGrow: 1,
                                                    fontSize: "13px",
                                                    color: "var(--secondary-color3)",
                                                    fontWeight: 400,
                                                    lineHeight: "20px",
                                                    boxShadow: "none",
                                                    padding: "3px 8px",
                                                    minHeight: "90px",
                                                    maxHeight: "140px",
                                                },
                                            }}
                                            containerStyle={{
                                                width: "100%",
                                            }}
                                            showLabel={false}
                                            rowsMin={1}
                                            rowsMax={3}
                                        />
                                    </div>
                                )}
                                <div className={styles.bottomWrap}>
                                    <Button
                                        text={"Submit"}
                                        handler={() => {
                                            setTimeout(() => {
                                                handleClose();
                                            }, 2000);
                                            handler({ stars: value, text });
                                            setThankYou(
                                                "Thank you for your feedback!",
                                            );
                                        }}
                                        style={{
                                            fontWeight: 500,
                                        }}
                                        disabled={value == 0}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className={styles.thankYouWrap}>
                                <SVGIcon
                                    src={"/New UI/SVG/feedback.svg"}
                                    size={80}
                                />
                                <div>{thankYou}</div>
                            </div>
                        )}
                    </div>
                </Modal>
            )}
            {!feedbackModal && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div
                        className={styles.feedbackCta}
                        onClick={() => {
                            !feedbackModal && setFeedbackModal(true);
                        }}
                    >
                        Help Us Improve
                    </div>
                    {/* <ReactStars
                        size={20}
                        count={5}
                        value={value}
                        onChange={(newVal) => {
                            setValue(newVal);
                            setFeedbackModal(true);
                        }}
                        color={"var(--tertiary-color4)"}
                        activeColor={"var(--primary-color1)"}
                    /> */}
                </div>
            )}
        </div>
    );
};

export default Feedback;
